import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useLanguage } from '../i18n/LanguageContext'

const Privacy = () => {
  const { lang } = useLanguage()

  useEffect(() => {
    const section = document.getElementsByClassName('cookie_declaration')[0];
    if (!section) return;
    const script = document.createElement('script');
    script.src = 'https://consent.cookiebot.com/3371ac60-fc7e-4d21-b621-e8ee73c431ff/cd.js';
    script.async = true;
    section.appendChild(script);
  }, [])

  const nl = (
    <>
      <h1>Privacybeleid</h1>
      <p>Verantwoordelijke: <strong>Parkinghaarlem</strong><br />Contact: <a href="mailto:info@parkinghaarlem.nl">info@parkinghaarlem.nl</a></p>

      <h2>Welke gegevens verzamelen we?</h2>
      <ul>
        <li><strong>Cookievoorkeur</strong> — We slaan je cookiekeuze op via Cookiebot zodat je niet bij elk bezoek opnieuw hoeft te kiezen.</li>
        <li><strong>Taalvoorkeur</strong> — We onthouden je gekozen taal (Nederlands of Engels) in je browser.</li>
        <li><strong>Bezoekersstatistieken</strong> — Via Umami Analytics verzamelen we anonieme bezoekersgegevens (geen cookies, geen persoonlijke data).</li>
        <li><strong>Advertentiecookies</strong> — Zodra advertenties actief zijn, kunnen advertentiepartners (zoals Google) cookies plaatsen voor gepersonaliseerde advertenties. Hiervoor vragen we altijd eerst je toestemming.</li>
      </ul>

      <h2>Waarvoor gebruiken we deze gegevens?</h2>
      <ul>
        <li>Om de website goed te laten werken</li>
        <li>Om inzicht te krijgen in het bezoekersgedrag (anoniem)</li>
        <li>Om relevante advertenties te tonen (alleen na toestemming)</li>
      </ul>

      <h2>Hoe lang bewaren we gegevens?</h2>
      <p>Cookievoorkeuren worden maximaal 12 maanden bewaard. Analytische gegevens zijn anoniem en worden niet aan personen gekoppeld.</p>

      <h2>Jouw rechten</h2>
      <p>Je hebt het recht om je gegevens in te zien, te corrigeren of te laten verwijderen. Neem hiervoor contact op via <a href="mailto:info@parkinghaarlem.nl">info@parkinghaarlem.nl</a>.</p>

      <h2>Cookieverklaring</h2>
      <div className="cookie_declaration"></div>
    </>
  )

  const en = (
    <>
      <h1>Privacy Policy</h1>
      <p>Responsible party: <strong>Parkinghaarlem</strong><br />Contact: <a href="mailto:info@parkinghaarlem.nl">info@parkinghaarlem.nl</a></p>

      <h2>What data do we collect?</h2>
      <ul>
        <li><strong>Cookie preference</strong> — We store your cookie choice via Cookiebot so you don't have to choose again on every visit.</li>
        <li><strong>Language preference</strong> — We remember your chosen language (Dutch or English) in your browser.</li>
        <li><strong>Visitor statistics</strong> — We use Umami Analytics to collect anonymous visitor data (no cookies, no personal data).</li>
        <li><strong>Advertising cookies</strong> — Once ads are active, advertising partners (such as Google) may place cookies for personalised ads. We always ask for your consent first.</li>
      </ul>

      <h2>Why do we use this data?</h2>
      <ul>
        <li>To keep the website functioning properly</li>
        <li>To gain insight into visitor behaviour (anonymously)</li>
        <li>To show relevant advertisements (only after consent)</li>
      </ul>

      <h2>How long do we store data?</h2>
      <p>Cookie preferences are stored for a maximum of 12 months. Analytical data is anonymous and not linked to individuals.</p>

      <h2>Your rights</h2>
      <p>You have the right to view, correct, or delete your data. Contact us at <a href="mailto:info@parkinghaarlem.nl">info@parkinghaarlem.nl</a>.</p>

      <h2>Cookie declaration</h2>
      <div className="cookie_declaration"></div>
    </>
  )

  return (
    <>
      <Helmet>
        <title>{lang === 'nl' ? 'Parking Haarlem | Privacybeleid' : 'Parking Haarlem | Privacy Policy'}</title>
        <meta name="description" content={lang === 'nl'
          ? 'Het privacybeleid van Parking Haarlem. Lees hoe wij omgaan met jouw gegevens.'
          : 'The privacy policy of Parking Haarlem. Read how we handle your data.'
        } />
      </Helmet>
      <section className="privacy_section">
        {lang === 'nl' ? nl : en}
      </section>
    </>
  )
}

export default Privacy
